<template>
    <v-text-field maxlength="1024"
                  :placeholder="text('api.patient.comment.placeholder')"
                  v-model="patientProfileData.comment"
                  @focus="setTemporaryPatientCommentValue"
                  @blur="savePatientComment($event)"
                  @mousedown.stop
                  id="comment"
                  v-if="getShowUserComment && !getMustShowVitalParamsForm"
                  ref="comment"
                  textarea
                  autofocus
                  rows="8"
                  class="patient-comment-header">
    </v-text-field>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "PatientCommentPopup",

    data () {
        return {
            tempPatientComment: null,
        }
    },

    computed: {
        ...mapGetters({
            getShowUserComment: 'TranslationStore/getShowUserComment',
            getShowUserCommentNoShortcut: 'TranslationStore/getShowUserCommentNoShortcut',
            getShowUserCommentShortcut: 'TranslationStore/getShowUserCommentShortcut',
            patientProfileData: 'AssessmentStartStore/getPatientProfileData',
            getMustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm'
        }),
    },

    methods: {

        isPatientCommentChanged() {
            return this.tempPatientComment !== this.patientProfileData.comment;
        },

        savePatientComment: function() {
            if (this.isPatientCommentChanged() && (this.getShowUserCommentNoShortcut || this.getShowUserCommentShortcut)) {
                if(this.$router.currentRoute.path === '/evaluation'){

                    this.$store.dispatch("AssessmentStartStore/submitPersistPatientProfileComment");
                }
                else {
                    this.$store.dispatch("AssessmentStartStore/submitPatientProfileComment", {
                        fieldName: "COMMENT",
                        fieldValue: this.patientProfileData.comment
                    });
                }
            }
            this.$store.commit('TranslationStore/setShowUserComment', false);
            this.$store.commit('TranslationStore/setShowUserCommentNoShortcut', false);

        },

        setTemporaryPatientCommentValue() {
            this.tempPatientComment = this.patientProfileData.comment;

            // Place cursor at the end of the patient comment text
            let commentId = document.getElementById("comment");
            if (commentId != null) {

                let commentLength = commentId.value.length;
                commentId.selectionStart = commentLength;
                commentId.selectionEnd = commentLength;
            }
        },
    },
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/professional/components/shared/PatientCommentPopup.vue